import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import TeacherHeader from "../common/TeacherHeader";
import { baseUrl } from "../../Utility/constants";

const TeachersLandingPage = () => {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/Dashboards/GetTeacherDashboard?teacherId=${localStorage.getItem(
          "userID"
        )}`
      );

      setDashboard(response.data);

      if (!sessionStorage.getItem("TeacherDashboardGreeting")) {
        Swal.fire({
          title: `Hi! ${localStorage.getItem("loggedUserFullName")} 👋`,
          text: "Have a wonderful day!",
          icon: "success",
          timer: 5000,
          showConfirmButton: false,
        });

        sessionStorage.setItem("TeacherDashboardGreeting", "true");
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  if (loading)
    return (
      <>
        <TeacherHeader />
        <div className="container mt-5 text-center">
          <div className="spinner-border text-primary"></div>
        </div>
      </>
    );

  return (
    <>
      <TeacherHeader />

      <div className="container mt-4">

        <div className="text-center mb-4">
          <h2 className="fw-bold">
            {dashboard?.isClassTeacher
              ? "Class Teacher Dashboard"
              : "Teacher Dashboard"}
          </h2>

          <p className="text-muted">
            Welcome <strong>{localStorage.getItem("UserName")}</strong>
          </p>
        </div>

      <div className="row g-4">

  {/* Left Column */}
  <div className="col-lg-4">

    {/* Students */}
    <div className="card shadow border-0 rounded-4 mb-4">
      <div className="card-header bg-primary text-white fw-bold">
        👨‍🎓 Students
      </div>

      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <span>Total Students</span>

          <span className="badge bg-primary fs-6">
            {dashboard?.totalStudents}
          </span>
        </div>
      </div>
    </div>

    {/* Certificate Mapping */}
    {/* {dashboard?.isClassTeacher && (
      <div className="card shadow border-0 rounded-4 mb-4">

        <div className="card-header bg-warning fw-bold">
          📄 Certificate Mapping
        </div>

        <div className="card-body">

          <div className="d-flex justify-content-between mb-3">

            <strong>Number Mapping</strong>

            <span className="badge bg-warning text-dark fs-6">
              {dashboard?.numberMapping?.mapped} / {dashboard?.numberMapping?.total}
            </span>

          </div>

          <div className="d-flex justify-content-between">

            <strong>LC Mapping</strong>

            <span className="badge bg-warning text-dark fs-6">
              {dashboard?.lcMapping?.mapped} / {dashboard?.lcMapping?.total}
            </span>

          </div>

        </div>

      </div>
    )} */}

    {/* Attendance */}
    {dashboard?.isClassTeacher && (
      <div className="card shadow border-0 rounded-4">

        <div className="card-header bg-info text-white fw-bold">
          📅 Today's Attendance
        </div>

        <div className="card-body text-center">

          {dashboard?.attendance?.marked ? (
            <h3 className="text-success mb-0">✔ Marked</h3>
          ) : (
            <h3 className="text-danger mb-0">✘ Not Marked</h3>
          )}

        </div>

      </div>
    )}

  </div>

  {/* Right Column */}
  <div className="col-lg-8">

    <div className="card shadow border-0 rounded-4 h-100">

      <div className="card-header bg-success text-white fw-bold">
        📚 Subject Wise Students
      </div>

      <div className="card-body">

        {dashboard?.subjectWiseStudents?.length === 0 && (
          <div>No Subjects Found</div>
        )}

        {dashboard?.subjectWiseStudents?.map((item, index) => (

          <div
            key={index}
            className="d-flex justify-content-between border-bottom py-2"
          >

            <span>{item.subject}</span>

            <span className="badge bg-success">
              {item.students}
            </span>

          </div>

        ))}

      </div>

    </div>

  </div>

  {/* Examination */}
  <div className="col-12">

    <div className="card shadow border-0 rounded-4">

      <div className="card-header bg-danger text-white fw-bold">
        📝 Examination
      </div>

      <div className="card-body">

        <table className="table table-bordered table-hover mb-0">

          <thead className="table-light">

            <tr>
              <th>Exam Type</th>
              <th>Completed</th>
              <th>Pending</th>
            </tr>

          </thead>

          <tbody>

            {dashboard?.examination?.map((exam, index) => (

              <tr key={index}>

                <td>{exam.examType}</td>

                <td>
                  <span className="badge bg-success">
                    {exam.completed}
                  </span>
                </td>

                <td>
                  <span className="badge bg-danger">
                    {exam.pending}
                  </span>
                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>

  </div>

</div>

      </div>
    </>
  );
};

export default TeachersLandingPage;